import { IDatabaseItem } from "../interfaces";

export const ALCOHOL_ITEMS: Array<IDatabaseItem> = [
	{
		title: "Hnusná vína",
		desc: "Chateu Valtice - všechny jakostní, B/V Ryzlink Vlašský 2021, Ludwig - Chardonnay, Veltlínské zelené",
		images: [{
			src: "01.webp",
			large: "01-large.webp",
		}],
	},
	{
		title: "Corsario - Reserve Cask",
		images: [{
			src: "02.webp",
			large: "02-large.webp",
		}],
	},
	{
		title: "Goral - Malinovica",
		images: [{
			src: "03.webp",
			large: "03-large.webp",
		}],
	},
	{
		title: "Veritas - 2017 agrolip pozdní sběr",
		images: [{
			src: "04.webp",
			large: "04-large.webp",
		}],
	},
];
